import { EpsiodeItemDashboard } from 'client/screens/AnalyticsDashboardScreen/types';
import { sortObjectArrayByDate } from '../Date';
import { Episode } from '../../types';

const getIsOnePublished = (episodes: Episode[] | EpsiodeItemDashboard[]) =>
  episodes.some(
    (episode: Episode | EpsiodeItemDashboard) =>
      (episode as Episode).status?.kind === 'published' ||
      (episode as EpsiodeItemDashboard).episodeStatus === 'published'
  );

const sortByDate = (episodes: Episode[]) =>
  sortObjectArrayByDate(episodes, 'desc', episode => episode.status.date);

export { getIsOnePublished, sortByDate };
